<!-- Modal Wrapper -->
<div *ngIf="showModal" class="modal-backdrop-wrapper">
  <!-- Backdrop -->
  <div class="modal-backdrop fade show" (click)="close()"></div>

  <!-- Modal -->
  <div class="custom-modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ vehicleData ? "Edit Vehicle" : "Add Vehicle" }}
          </h5>
          <button type="button" class="close" (click)="close()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="vehicleForm" (ngSubmit)="submitForm()">
            <div class="form-group">
              <label>Truck Type</label>
              <input
                type="text"
                class="form-control"
                formControlName="truckType"
              />
              <div
                *ngIf="
                  vehicleForm.get('truckType')?.touched &&
                  vehicleForm.get('truckType')?.invalid
                "
                class="text-danger"
              >
                Truck Type is required.
              </div>
            </div>

            <div class="form-group">
              <label>Upload Image</label>
              <div class="d-flex align-items-center">
                <!-- File input -->
                <input
                  type="file"
                  class="form-control me-3"
                  style="max-width: 350px"
                  (change)="onImageSelected($event)"
                  accept="image/*"
                />

                <!-- Image Preview -->
                <div *ngIf="imagePreview">
                  <img
                    [src]="imagePreview"
                    alt="Preview"
                    style="
                      max-height: 60px;
                      border: 1px solid #a0ed8b;
                      border-radius: 4px;
                    "
                  />
                </div>
              </div>

              <!-- Error -->
              <div *ngIf="imageUploadError" class="text-danger mt-1">
                {{ imageUploadError }}
              </div>
            </div>

            <div class="form-group">
              <label>Vehicle Length (m)</label>
              <input
                type="text"
                class="form-control"
                formControlName="vehicleLength"
              />
              <div
                *ngIf="
                  vehicleForm.get('vehicleLength')?.touched &&
                  vehicleForm.get('vehicleLength')?.invalid
                "
                class="text-danger"
              >
                Enter a valid length.
              </div>
            </div>

            <div class="form-group">
              <label>Vehicle Breadth (m)</label>
              <input
                type="text"
                class="form-control"
                formControlName="vehicleBreadth"
              />
              <div
                *ngIf="
                  vehicleForm.get('vehicleBreadth')?.touched &&
                  vehicleForm.get('vehicleBreadth')?.invalid
                "
                class="text-danger"
              >
                Enter a valid breadth.
              </div>
            </div>

            <div class="form-group">
              <label>Vehicle Height (m)</label>
              <input
                type="text"
                class="form-control"
                formControlName="vehicleHeight"
              />
              <div
                *ngIf="
                  vehicleForm.get('vehicleHeight')?.touched &&
                  vehicleForm.get('vehicleHeight')?.invalid
                "
                class="text-danger"
              >
                Enter a valid height.
              </div>
            </div>

            <div class="form-group">
              <label>Truck Tyres</label>
              <input
                type="text"
                class="form-control"
                formControlName="truckTyres"
              />
              <div
                *ngIf="
                  vehicleForm.get('truckTyres')?.touched &&
                  vehicleForm.get('truckTyres')?.invalid
                "
                class="text-danger"
              >
                Truck Tyres are required.
              </div>
            </div>

            <button type="submit" class="btn btn-success mt-3">
              {{ vehicleData ? "Update" : "Add" }} Vehicle
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
